"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextArea = exports.InputNumber = exports.Input = exports.default = void 0;

require("antd/es/input-number/style");

var _inputNumber = _interopRequireDefault(require("antd/es/input-number"));

require("antd/es/input/style");

var _input = _interopRequireDefault(require("antd/es/input"));

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./input.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Input = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var rest = _extends({}, _ref);

  return /*#__PURE__*/_react.default.createElement(_input.default, _extends({
    ref: ref,
    autoComplete: "off"
  }, rest));
});

exports.Input = Input;

var InputNumber = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
  var rest = _extends({}, _ref2);

  return /*#__PURE__*/_react.default.createElement(_inputNumber.default, _extends({
    ref: ref,
    autoComplete: "off"
  }, rest));
});

exports.InputNumber = InputNumber;
var TextArea = _input.default.TextArea;
exports.TextArea = TextArea;
var Search = _input.default.Search;
var Group = _input.default.Group;
var Password = _input.default.Password;
Input.TextArea = TextArea;
Input.Search = Search;
Input.Group = Group;
Input.Password = Password;

var _default = /*#__PURE__*/_react.default.forwardRef(function (_ref3, ref) {
  var type = _ref3.type,
      rest = _objectWithoutProperties(_ref3, ["type"]);

  if (type === "number") return /*#__PURE__*/_react.default.createElement(InputNumber, _extends({
    ref: ref
  }, rest));
  if (type === "textarea") return /*#__PURE__*/_react.default.createElement(TextArea, _extends({
    ref: ref
  }, rest));
  return /*#__PURE__*/_react.default.createElement(Input, _extends({
    ref: ref
  }, rest));
});

exports.default = _default;